import PropTypes from "prop-types";
import React, { useState } from "react";
import auth from "../../../services/auth";
import mediaService from "../../../services/media";
import storyService from "../../../services/story";
import ListSelectionItems from "../../media-output/lists/list-selection-items/list-selection-items";
import FilterFiles from "../../search/filter-files/filter-files";
import SearchWrapper from "../search-wrapper/search-wrapper";
import styles from "./attach-media.module.scss";
import GenericMessage from "../../common/generic-message/generic-message";

const AttachMedia = ({ attachedMedia, onMediaAttached, allowedMediaTypes, mediaType }) => {
  const [internalMedia, setInternalMedia] = useState(attachedMedia);
  const [errorMessage, setErrorMessage] = useState("");  // For error handling
  const [loading, setLoading] = useState(false);  // To handle loading state

  const cardClickFn = (data) => {
    setLoading(true);
    setErrorMessage("");  // Reset any error message on new click

    console.log("Card clicked:", data);
    // Check if the clicked data is of the correct media type
    if (data.type === mediaType) {
      // Fetch media
      mediaService.getMedia(data.id)
        .then((result) => {
          setInternalMedia(result);
          onMediaAttached(result);
        })
        .catch((error) => {
          setErrorMessage("Failed to fetch media.");
          setTimeout(() => setErrorMessage(""), 1000);
        })
        .finally(() => setLoading(false));
    } else {
      // Check for story data
      storyService.getStory(data.id)
        .then((result) => {
          if (result) {
            setInternalMedia(result);
            onMediaAttached(result);
          } else {
            setErrorMessage("No story found.");
            setTimeout(() => setErrorMessage(""), 1000);
          }
        })
        .catch((error) => {
          setErrorMessage("Failed to fetch story.");
          setTimeout(() => setErrorMessage(""), 1000);
        })
        .finally(() => setLoading(false));
    }
  };

  const clearInternalMedia = () => {
    setInternalMedia(null);
    onMediaAttached(null);
  };

  const listMediaFn = () => {
    const authObj = auth.getAuth();
    return {
      query: {
        bool: {
          must: [
            {
              match: {
                branch: {
                  query: authObj.user.branch.id,
                  operator: "and",
                },
              },
            },
          ],
        },
      },
    };
  };

  const getSearchMedia = () => {
    return (
      <div className={styles?.wrapper}>
        <SearchWrapper index="media" searchPath={"search"}>
          <div className={styles?.searchBar}>
            <FilterFiles availableFilters={["title"]} simpleVerticalSearch={true} />
          </div>
          <div>
            <ListSelectionItems defaultQueryFn={listMediaFn} onCardClick={cardClickFn} />
          </div>
        </SearchWrapper>
      </div>
    );
  };

  return (
    <>
      {loading && <p>Loading...</p>}
      {errorMessage && <GenericMessage message={errorMessage} type="error" closeIcon
        setTime />}
      {getSearchMedia()}
    </>
  );
};

AttachMedia.propTypes = {
  attachedMedia: PropTypes.array,
  onMediaAttached: PropTypes.func.isRequired,
};

export default AttachMedia;